import * as Proxy from './Proxy'

export default (function () {
    const baseUrl = "/paymentlobby/api/PaymentPlan/";
    return {
        GetPaymentPlanReview(request) {
            var url = baseUrl + "GetPaymentPlanReview";
            return Proxy.Post(url, request);
        },
        GetPaymentPlanHistory(request) {
            var url = baseUrl + "GetPaymentPlanHistory";
            return Proxy.Post(url, request);
        },
        GetPayPlanInstallments(request) {
            var url = baseUrl + "GetPayPlanInstallments";
            return Proxy.Post(url, request);
        },
        GetCustomerPaymentPlanEligibleInvoices(request) {
            var url = baseUrl + "GetCustomerPaymentPlanEligibleInvoices";
            return Proxy.Post(url, request);
        },
        SavePaymentPlan(request) {
            var url = baseUrl + "SavePaymentPlan";
            return Proxy.Post(url, request);
        },
        CancelPaymentPlan(request) {
            var url = baseUrl + "CancelPaymentPlan";
            return Proxy.Post(url, request);
        },
        GetCustomerBalance(request) {
            var url = baseUrl + "GetCustomerBalance";
            return Proxy.Post(url, request);
        },
        //ApplyCreditToDPP(request) {
        //    var url = baseUrl + "ApplyCreditToDPP";
        //    return Proxy.Post(url, request);
        //},
        GetCustomerInfo(request) {
            var url = baseUrl + "GetCustomerInfo";
            return Proxy.Post(url, request);
        },
        GetDeferredPaymentPlanInformation(request) {
            var url = baseUrl + "GetDeferredPaymentPlanInformation";
            return Proxy.Post(url, request);
        },
        GetDepositInformationForDeferredPaymentPlan(request) {
            var url = baseUrl + "GetDepositInformationForDeferredPaymentPlan";
            return Proxy.Post(url, request);
        }
    };
})()